"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForwarderMock__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "from",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "gas",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct ForwarderMock.ForwardRequest",
                name: "req",
                type: "tuple",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ForwarderMock__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ForwarderMock__factory = ForwarderMock__factory;
ForwarderMock__factory.bytecode = _bytecode;
ForwarderMock__factory.abi = _abi;
//# sourceMappingURL=ForwarderMock__factory.js.map